import React from 'react'
import Budget from 'src/app/Budget/Budget'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import BudgetHistoryAppRoute from 'src/navigation/appRoutes/budget/budgetHistory.appRoute'
import BudgetOverviewAppRoute from 'src/navigation/appRoutes/budget/budgetOverview.appRoute'
import BudgetTransactionsAppRoute from 'src/navigation/appRoutes/budget/budgetTransactions.appRoute'
import BudgetVirtualCardsAppRoute from 'src/navigation/appRoutes/budget/budgetVirtualCards.appRoute'
import BudgetsAllBudgetsAppRoute from 'src/navigation/appRoutes/budgets/budgetsAllBudgets.appRoute'
import BudgetsNeedsApprovalAppRoute from 'src/navigation/appRoutes/budgets/budgetsNeedsApproval.appRoute'
import BudgetsRequestsAppRoute from 'src/navigation/appRoutes/budgets/budgetsRequests.appRoute'
import { budgetRouteProps } from 'src/navigation/routeProps'

const BudgetAppRoute: AppRoute = {
  id: AppLocation.BudgetDetail,
  routeProps: budgetRouteProps,
  component: <Budget />,
  subRoutes: [
    BudgetOverviewAppRoute,
    BudgetVirtualCardsAppRoute,
    BudgetTransactionsAppRoute,
    BudgetHistoryAppRoute,
  ],
  exceptions: [
    BudgetsAllBudgetsAppRoute,
    BudgetsRequestsAppRoute,
    BudgetsNeedsApprovalAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetAppRoute
